export enum ProductType {
  TravelProduct = 'travel-product',
  Railcard = 'railcard-product',
  Season = 'season-ticket-product',
  Insurance = 'insurance-product',
  Travelcard = 'travelcard-product', // FIXME: Rename this to LocalArea since this is also including PlusBus
}

export default ProductType;
